import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import ImgWebp from '../Healthcare Software/Img/patnerwithus.gif';
import Img2 from "../Healthcare Software/Img/medisevasappoinmentPortalImg/appointment img1.webp";
import Img3 from "../Healthcare Software/Img/medisevasappoinmentPortalImg/imghomepagebanner 3 (1).webp";
import Img4 from "../Healthcare Software/Img/medisevasappoinmentPortalImg/imghomepagebanner 4 (1).webp";
import Img5 from "../Healthcare Software/Img/medisevasappoinmentPortalImg/imghomepagebanner 5.png";

// Data array remains the same
const servicesData = [
  {
    imgSrc: Img2,
    imgAlt: "Advanced BI Dashboard",
    title: "Powerful Analytics with Advanced BI Dashboard",
    description: `Our advanced BI dashboard provides healthcare providers with powerful analytics tools to gain insights into patient flow, appointment trends, and operational efficiency. This data-driven approach enables informed decision-making and continuous improvement.`,
    imgFirst: true,
  },
  {
    imgSrc: Img3,
    imgAlt: "Customizable Analytics",
    title: "Customizable Analytics to Achieve Your Goals",
    description: `Our customizable analytics feature allows healthcare providers to tailor their data insights to meet specific goals. By leveraging advanced filtering and reporting options, users can focus on the metrics that matter most to their practice.`,
    imgFirst: false,
  },
  {
    imgSrc: Img4,
    imgAlt: "Smart Notifications & Reminders",
    title: "Smart Notifications & Reminders for Analytics",
    description: `Our smart notifications and reminders system ensures that healthcare providers receive timely insights and alerts related to their analytics. By leveraging automated notifications, users can stay informed about key metrics and trends, enabling proactive decision-making.`,
    imgFirst: true,
  },
  {
    imgSrc: Img5,
    imgAlt: "Hospital Flow Control",
    title: "Hospital Flow Control & Optimization",
    description: `Our hospital flow control and optimization solutions empower healthcare providers to streamline operations, reduce bottlenecks, and enhance patient experiences. By leveraging data-driven insights, we help organizations achieve greater efficiency and effectiveness in their workflows.`,
    imgFirst: false,
  },
];


const internalStyles = `
  :root {
    --medisevas-blue: #0084d9;
    --medisevas-green: #0d622b;
    --medisevas-black: #000;
    --medisevas-light-bg: #f7f7f7;
  }
  
  /* --- Global Section/Typography Refinements --- */
  .section, section {
    scroll-margin-top: 90px;
    overflow: clip;
    color: var(--medisevas-black);
    background-color: #fff;
    padding: 80px 0; /* Increased vertical padding for more breathing room */
  }
  @media (max-width: 1199px) {
    .section, section {
      scroll-margin-top: 66px;
      padding: 60px 0;
    }
  }
  
  .section-title h2 {
    color: var(--medisevas-green);
    font-weight: 700;
    position: relative;
    padding-bottom: 15px;
    text-transform: uppercase;
  }
  .section-title h2:after {
    content: "";
    position: absolute;
    display: block;
    width: 60px;
    height: 4px;
    background: var(--medisevas-blue);
    bottom: 0;
    left: calc(50% - 30px);
    border-radius: 2px;
  }
  .section-title p {
    color: #444;
    font-size: 1.1rem;
    max-width: 800px; /* Constrain paragraph width for better readability */
    margin: 10px auto 0;
  }
  
  /* --- Feature Section Styles (Top Block) --- */
  .medisevas-section {
    color: #0d622b;
    background-color: #f7f9fa;
    padding: 80px 0;
    font-family: 'Roboto', system-ui, sans-serif;
  }
  .medisevas-section-title {
    margin-bottom: 40px; 
  }
  
  .medisevas-tab-pane {
    background: #fff;
    border-radius: 12px;
    margin-bottom: 32px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
    padding: 40px; 
  }

  .medisevas-feature-list {
    padding-left: 0; 
  }

  .medisevas-feature-list li {
    margin-bottom: 12px;
    list-style: none;
    display: flex;
    align-items: flex-start;
    padding-left: 0;
    font-size: 1rem;
    color: #333;
  }
  .medisevas-feature-list li i {
    color: var(--medisevas-blue);
    margin-right: 10px;
    font-size: 1.2em;
    min-width: 20px;
  }
  
  /* Image Styles */
  section#features img.img-fluid {
    max-width: 100%;
    height: auto;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    user-select: none;
  }

  /* --- Service Card Styles (Alternating Feature Blocks) --- */
  .service-card {
    background: #ffffff;
    /* Reverting to closer to original service-card styles for consistency, but improved spacing/layout maintained */
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1); 
    border-radius: 8px; 
    padding: 40px; 
    transition: box-shadow 0.3s ease;
    display: flex;
    flex-direction: column;
    gap: 2rem;
    align-items: center; 
  }
  .service-card:hover {
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15); /* Hover shadow from original */
  }
  
  @media (min-width: 992px) {
    .service-card {
      flex-direction: row;
      align-items: center; 
    }
    .service-img-wrapper {
      max-width: 45%; 
      width: 100%; /* Ensure max-width is respected */
      flex-shrink: 0;
    }
    .service-text {
      max-width: 55%;
      padding: 0 20px;
    }
  }
  
  .service-text h4 {
    color: var(--medisevas-green); /* Using green for h4 in services */
    font-weight: 700;
    margin-bottom: 1rem;
    font-size: 1.75rem;
  }
  
  .service-text p {
    color: #444; /* Using #444 from original service-text p */
    line-height: 1.6; /* Using 1.6 from original service-text p */
    font-size: 1rem;
  }

  /* --- CTA Section Styles (medisevas-dark-bg) --- */
  .medisevas-dark-bg {
    /* Using the linear-gradient from your provided styles */
    background:  #a3cfbb;
    color: var(--medisevas-black);
    padding: 80px 0; /* Ensuring consistent section padding */
  }
  .medisevas-dark-bg h3 {
    /* Styles for the main CTA title */
    color: var(--medisevas-green);
    font-weight: 700;
    margin-bottom: 1.5rem;
    font-size: 2rem; /* Enhanced size for impact */
  }
  .medisevas-dark-bg p {
    font-size: 1.1rem;
    margin-bottom: 2.5rem;
    color: #444;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
  }
  
  /* Button Styles (Re-consolidated from provided styles) */
  .medisevas-btn {
    background-color: var(--medisevas-blue);
    border: none;
    color: #fff;
    padding: 10px 20px;
    margin: 0 4px; /* Adjusting margin for cleaner button grouping */
    border-radius: 6px;
    font-weight: 600;
    transition: background 0.2s;
    cursor: pointer;
    text-decoration: none;
    display: inline-block;
  }
  .medisevas-btn-success {
    background-color: var(--medisevas-green);
  }
  .medisevas-btn-outline {
    background: none;
    color: var(--medisevas-green);
    border: 2px solid var(--medisevas-green);
  }
  .medisevas-btn:hover,
  .medisevas-btn-success:hover {
    background-color: var(--medisevas-green);
    color: #fff;
    text-decoration: none;
  }
  .medisevas-btn-outline:hover {
    background-color: var(--medisevas-green);
    color: #fff;
  }
  .hero-buttons {
    margin-top: 30px;
  }
  .mb-3 {
    margin-bottom: 1rem !important; /* Bootstrap mb-3 value */
  }
  .py-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
`;

const HealthCareAnalytics = ({ history }) => {
  const navigateAndScroll = (path) => (e) => {
    e.preventDefault();
    if (history && typeof history.push === "function") {
      history.push(path);
    } else {
      // Fallback for non-router environments or modern react-router-dom v6 (replace with useNavigate hook)
      // If history is not available, it still performs the scroll and navigates via native URL change
      window.location.href = path;
    }
    window.scrollTo(0, 0);
  };

  return (
    <>
      <style>{internalStyles}</style>
      <div className="light-background">
      {/* 1. Why Choose Section - Class 'section-title' added to activate ::after */}
      <section
        id="features"
        className="container medisevas-section medisevas-features mt-5"
      >
        <Container className="section-title medisevas-section-title text-center">
          <h2>
            Why Choose The Medisevas Cloud-based Healthcare Software & Solutions
          </h2>
          <p>
            Providing accurate data, smooth department integration, and
            adaptable solutions that boost overall effectiveness and patient
            care, Medisevas Software is a dependable hospital management system
            that improves hospital operations.
          </p>
        </Container>
        <Container>
          <Row className="medisevas-tab-pane align-items-center py-4">
            <Col
              lg={7}
              className="mt-1 d-flex flex-column justify-content-center"
            >
              <h3
                className="mb-3"
                style={{  fontWeight: 600 }}
              >
                Hospital Analytics Management
              </h3>
              <p className="fst-italic" style={{ color: "#444" }}>
                Medisevas Hospital Analytics Management is a comprehensive
                solution designed to streamline and enhance the operational
                efficiency of healthcare facilities. It offers a wide range of
                features that cater to the diverse needs of hospitals, clinics,
                and other medical institutions.
              </p>
              <Row className="mt-3">
                <Col md={6}>
                  <ul className="medisevas-feature-list">
                    <li>
                      <i className="bi bi-check2-all"></i>Analytics Dashboard
                    </li>
                    <li>
                      <i className="bi bi-check2-all"></i>Customizable Reports
                    </li>
                    <li>
                      <i className="bi bi-check2-all"></i>Data Visualization
                    </li>
                    <li>
                      <i className="bi bi-check2-all"></i>Predictive Analytics
                    </li>
                    <li>
                      <i className="bi bi-check2-all"></i>Patient Segmentation
                    </li>
                    <li>
                      <i className="bi bi-check2-all"></i>Real-time Analytics
                    </li>
                  </ul>
                </Col>

                <Col md={6}>
                  <ul className="medisevas-feature-list">
                    <li>
                      <i className="bi bi-check2-all"></i>BI Dashboard
                    </li>
                    <li>
                      <i className="bi bi-check2-all"></i>Customizable Analytics
                    </li>
                    <li>
                      <i className="bi bi-check2-all"></i>Data Export
                    </li>
                    <li>
                      <i className="bi bi-check2-all"></i>Data Import
                    </li>
                    <li>
                      <i className="bi bi-check2-all"></i>Customizable
                      Dashboards
                    </li>
                    <li>
                      <i className="bi bi-check2-all"></i>360 Degree Hospital
                      View
                    </li>
                  </ul>
                </Col>
              </Row>
            </Col>
            <Col
              lg={5}
              className="text-center mt-4 mt-lg-0 d-flex align-items-center justify-content-center"
            >
              <img
                src={ImgWebp}
                alt="Features Illustration"
                className="img-fluid"
                draggable={false}
                style={{ height:"450px" }}
              />
            </Col>
          </Row>
        </Container>
      </section>
    </div>
      {/* 2. Services Section - Alternating Layout with Refined Cards */}
      <section id="services" className="container services section light-background">
        <Container>
          <div className="section-title text-center mb-5">
            <h2>Achieve More With Medisevas HealthCare Software</h2>
            <p>
              Designed to operate locally for your convenience. Appreciated
              worldwide across various continents.
            </p>
          </div>

          <Row className="g-5">
            {servicesData.map((service, idx) => (
              <Col key={idx} lg={12}>
                {/* Use Row/Col layout inside to manage alternating image/text */}
                <div className="service-card">
                  {service.imgFirst && (
                    <div className="service-img-wrapper">
                      <img
                        src={service.imgSrc}
                        alt={service.imgAlt}
                        className="img-fluid"
                        draggable={false}
                      />
                    </div>
                  )}
                  <div className="service-text">
                    <h4>{service.title}</h4>
                    <p>{service.description}</p>
                  </div>
                  {!service.imgFirst && (
                    <div className="service-img-wrapper">
                      <img
                        src={service.imgSrc}
                        alt={service.imgAlt}
                        className="img-fluid"
                        draggable={false}
                      />
                    </div>
                  )}
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* 3. CTA Section - Using the requested markup and consolidated styles */}
      <section className="medisevas-section medisevas-dark-bg py-5">
        <div className="container text-center">
          <h3>
            Assisting You in Expanding Without Boundaries,
            <br />
            Your Development is Our Main Concern
          </h3>
          <p>
            Schedule a demonstration, and our representative will provide you
            with an in-depth overview of our product and address any lingering
            questions.
          </p>
          <div className="hero-buttons mb-3">
            {/* Contact with Us */}
            <a
              className="medisevas-btn medisevas-btn-outline mx-1"
              href="/contact-us"
              onClick={navigateAndScroll("/contact-us")}
            >
              Contact with Us
            </a>

            {/* Book a Demo */}
            <a
              className="medisevas-btn medisevas-btn-success mx-1"
              href="/contact-us"
              onClick={navigateAndScroll("/contact-us")}
            >
              Book a Demo
            </a>

            {/* Partner with Us */}
            <a
              className="medisevas-btn medisevas-btn-outline mx-1"
              href="/partner-with-us"
              onClick={navigateAndScroll("/partner-with-us")}
            >
              Partner with Us
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default HealthCareAnalytics;
